import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { Toaster } from 'react-hot-toast';
import { queryClient } from './lib/queryClient';
import {
  queryClientPersistOptions,
} from './lib/queryPersister';
import { ClerkProvider } from './lib/clerk';
import { ThemeProvider } from './lib/theme';
import { App } from './App';
import { installAssetLoadRecovery } from './lib/assetLoadRecovery';
import './styles/globals.css';

installAssetLoadRecovery();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <ClerkProvider>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={queryClientPersistOptions}
      >
        <ThemeProvider>
          <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'hsl(var(--card))',
              color: 'hsl(var(--card-foreground))',
              border: '1px solid hsl(var(--border))',
              borderRadius: '0.5rem',
              padding: '12px 16px',
              fontFamily: 'Instrument Sans, system-ui, sans-serif',
            },
            success: {
              iconTheme: {
                primary: 'hsl(var(--success))',
                secondary: 'hsl(var(--card))',
              },
            },
            error: {
              iconTheme: {
                primary: 'hsl(var(--destructive))',
                secondary: 'hsl(var(--card))',
              },
            },
          }}
        />
        </ThemeProvider>
      </PersistQueryClientProvider>
    </ClerkProvider>
  </StrictMode>
);
